import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';

interface SendEmailToClientParams {
  clientId: string;
  managedAccountId: string;
}

const sendEmailToClient = ({ clientId, managedAccountId }: SendEmailToClientParams) =>
  authFetch(
    urlWithParams('/Consumer/ManagedAccounts/SendEmailToClient', {
      clientId,
      id: managedAccountId,
    }),
    {
      method: 'POST',
    },
  );

export const useSendEmailToClientMutation = () => {
  return useMutation(sendEmailToClient);
};
